import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="container-footer d-flex align-items-center justify-content-center ">
      <p className="text-light text-muted">
        {" "}
        Copyright @ 2022 All Rights Reserved.
      </p>
    </div>
  );
};

export default Footer;
